function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="AccessibleNav"] .sub-menu-block').forEach((subMenu) => {
  subMenu.setAttribute('role', 'menu');
});

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return;
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
    if (mouseClick) return;
    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');
  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);
  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;
  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    const IncValue = this.input.value;
    var priceElement =  document.querySelector('.product__info-container');
    var priceElementDIV = document.querySelector('.price-wrapper');
    if(!priceElementDIV) return;
    var currentPrice =  priceElement.querySelector('.product-price-current');   
    const priceData = currentPrice.dataset.price;   
    var SubPrice = priceData.replace(/[^0-9\.]/g, '');   
    var ReultPrice =  SubPrice.replace(/^(\.+)/g, '');     
    var EvalPrice = parseInt(ReultPrice)    
    var subtotal = (IncValue * EvalPrice);                   
    var subtotalElement =  document.getElementById('subtotal-value');    
    if(!subtotalElement) return;
    subtotalElement.innerText = Shopify.formatMoney(subtotal+'.00', DT_THEME.moneyFormat);        
  }
}

customElements.define('quantity-input', QuantityInput);
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }
      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;
    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    var topBarHeight = document.getElementById('shopify-section-top-bar').offsetHeight;    
    document.getElementById("menu-drawer").style.top = '-'+topBarHeight+"px";    
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;
    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }
      const elapsedTime = time - animationStart;
      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };
    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;    
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();    
    const modalXClosethis = this.querySelector('[id^="ModalClose-"]');
    if(!modalXClosethis) return;
    modalXClosethis.addEventListener('click',this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {  
    if (!this.slider || !this.nextButton) return;
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }
    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }
    if (this.enableSliderLooping) return;
    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }
    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.slider = this.querySelector('[data-slider-options]');
    this.init();
  }

  init() {
    const predefine = {
      effect: 'slide',
      direction: 'horizontal',
      autoplay: true,
      autoplaySpeed: 5,
      space: 0,
      center: true,
      options: {},
    };    
    const slider_options = this.slider.getAttribute('data-slider-options');
    if (slider_options === null || slider_options === '') return null;
    const grouping = $.extend(true, predefine, JSON.parse(slider_options));
    
    const isNumberic = /^\d+$/;
    Object.keys(grouping).forEach((key) => {
      if (typeof grouping[key] === 'string' && isNumberic.test(grouping[key])) {
        grouping[key] = parseInt(grouping[key], 10);
      }
    });
    let autoplay = false;
    if (grouping.auto_play > 0) {
      autoplay = { delay: grouping.auto_play * 1000 };
    }
    let loop = false;
    if (grouping.loop === 'true' || grouping.loop === true) {
      loop = true;
    }
    const option = $.extend(true, {
      init: false,
      spaceBetween: 0,
      loop,
      autoplay,
      speed: 2000,
      navigation: {
        nextEl: this.slider.querySelector('.swiper-button-next'),
        prevEl: this.slider.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: this.slider.querySelector('.swiper-pagination'),
        clickable: true,
      },
      lazy: true,
      effect: grouping.effect,
    }, grouping.options);
    const container = this.slider.querySelector('[data-swiper-slider]');
    const initiate = new Swiper(container, option);
    initiate.on('init', () => { initiate.update(); });
    initiate.init();
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.updateVariantStatuses();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {        
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {     
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;
    if (this.currentVariant && this.currentVariant.available) {   
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;
    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);        
        if (source && destination) destination.innerHTML = source.innerHTML;
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
        
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
        }
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;

        const stickyDestination = document.getElementById(`sticky-price-${this.dataset.section}`);
        const stickySource = html.getElementById(`sticky-price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (stickySource && stickyDestination) stickyDestination.innerHTML = stickySource.innerHTML;
        
        const stickyPrice = document.getElementById(`sticky-price-${this.dataset.section}`); 
        if (stickyPrice) stickyPrice.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

        const destination2 = document.getElementById(`subtotal-${this.dataset.section}`);
        const source2 = html.getElementById(`subtotal-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source2 && destination2) destination2.innerHTML = source2.innerHTML;

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const stickButton = document.getElementById('sticky-bar-button');
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');    
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');      
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!stickButton) return;    
    if (disable) {      
      stickButton.setAttribute('disabled', 'disabled');      
    } else {      
      stickButton.removeAttribute('disabled');      
    }
    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;        
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }
  
  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {            
      fieldset.querySelector('.append-options-values').lastChild.textContent = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;      
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;      
    });
  }
}

customElements.define('variant-radios', VariantRadios);

/* ═══════════════════════════════════════════════════════════════
   UNIFIED SWIPER SLIDER
   Replaces 15 near-identical slider classes with ONE configurable class.
   Each tag name maps to a config for breakpoints and special features.
   ═══════════════════════════════════════════════════════════════ */
(function() {
  // Breakpoint configs per tag name: [mobile, tablet, laptop, desktop] pixel values
  // Plus optional overrides for special behavior
  var SLIDER_CONFIGS = {
    'swiper-slider':             { bp: [320,480,750,1024], space: 20, sel: 'data-swiper-slider' },
    'featured-swiper-slider':    { bp: [320,576,781,1200], space: 30, sel: 'data-swiper-slider', scrollbar: true, autoplayFixed: {delay:5000,disableOnInteraction:false,pauseOnMouseEnter:true} },
    'brand-slider':              { bp: [320,400,750,992,1600], space: 30, sel: 'data-swiper-slider', fiveBp: true },
    'collection-swiper-slider':  { bp: [320,767,1200,1540], space: 20, sel: 'data-swiper-slider', mobileSpace: 10 },
    'insta-slider':              { bp: [320,600,989,1201,1541], space: 20, sel: 'data-insta-slider', fiveBp: true, mobileSpace: 10, extraTablet: true },
    'flex-slider':               { bp: [320,560,990], space: 0, sel: 'data-flex-slider', threeBp: true, noCenterMobile: true },
    'recommendation-slider':     { bp: [320,576,990,1541], space: 30, sel: 'data-swiper-slider', mobileSpace: 10 },
    'multi-slider':              { bp: [320,577,991,1200], space: 30, sel: 'data-swiper-slider' },
    'blog-slider':               { bp: [320,577,990,1200], space: 30, sel: 'data-swiper-slider' },
    'support-slider':            { bp: [320,576,1024,1440], space: 20, sel: 'data-swiper-slider' },
    'grid-slider':               { bp: [320,576,991,1200], space: 20, sel: 'data-swiper-slider' },
    'product-scroll-slider':     { bp: [320,560,992], space: 0, sel: 'data-flex-slider', threeBp: true, vertical: true },
    'image-scroll-slider':       { bp: null, space: 0, sel: 'data-swiper-slider', vertical: true, mousewheel: true, singleSlide: true },
    'testimonial-slider':        { bp: [320,480,750,1024], space: 20, sel: 'data-swiper-slider' },
  };

  class UnifiedSwiper extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[data-slider-options]');
      this.init();
    }

    init() {
      var e = this.slider.getAttribute('data-slider-options');
      if (e === null || e === '') return;

      var tagName = this.tagName.toLowerCase();
      var cfg = SLIDER_CONFIGS[tagName] || SLIDER_CONFIGS['swiper-slider'];

      var t = $.extend(true, {
        effect: 'slide',
        direction: cfg.vertical ? 'vertical' : 'horizontal',
        autoplay: true,
        autoplaySpeed: 5,
        space: cfg.space || 0,
        center: true,
        options: {}
      }, JSON.parse(e));

      // Parse numeric strings
      var isNum = /^\d+$/;
      Object.keys(t).forEach(function(k) {
        if (typeof t[k] === 'string' && isNum.test(t[k])) t[k] = parseInt(t[k], 10);
      });

      // Autoplay
      var autoplay = false;
      if (cfg.autoplayFixed) {
        autoplay = cfg.autoplayFixed;
      } else if (t.auto_play > 0) {
        autoplay = { delay: t.auto_play * 1000 };
      }

      // Loop & centered
      var loop = false, centered = false;
      if (t.loop === 'true' || t.loop === true) { loop = true; }
      else if (t.loop === 1) { loop = true; centered = true; }

      // Build breakpoints
      var breakpoints = {};
      if (cfg.singleSlide) {
        // image-scroll-slider: single slide, vertical, mousewheel
      } else if (cfg.bp) {
        var bp = cfg.bp;
        if (cfg.threeBp) {
          breakpoints[bp[0]] = { slidesPerView: t.mobile, slidesPerColumn: 1, centeredSlides: cfg.noCenterMobile ? false : undefined };
          breakpoints[bp[1]] = { slidesPerView: t.tablet, slidesPerColumn: 1, centeredSlides: cfg.noCenterMobile ? false : undefined };
          breakpoints[bp[2]] = { slidesPerView: t.desktop, slidesPerColumn: 1 };
        } else if (cfg.fiveBp) {
          // 5-breakpoint configs (brand-slider, insta-slider)
          if (cfg.extraTablet) {
            // insta-slider: has mobile+1 at second breakpoint
            breakpoints[bp[0]] = { slidesPerView: t.mobile, slidesPerColumn: 1, spaceBetween: cfg.mobileSpace || cfg.space };
            breakpoints[bp[1]] = { slidesPerView: t.mobile + 1, slidesPerColumn: 1 };
            breakpoints[bp[2]] = { slidesPerView: t.tablet, slidesPerColumn: 1 };
            breakpoints[bp[3]] = { slidesPerView: t.laptop, slidesPerColumn: 1 };
            breakpoints[bp[4]] = { slidesPerView: t.desktop, slidesPerColumn: 1 };
          } else {
            // brand-slider
            breakpoints[bp[0]] = { slidesPerView: 1, slidesPerColumn: 1 };
            breakpoints[bp[1]] = { slidesPerView: t.mobile, slidesPerColumn: 1 };
            breakpoints[bp[2]] = { slidesPerView: t.tablet, slidesPerColumn: 1 };
            breakpoints[bp[3]] = { slidesPerView: t.laptop, slidesPerColumn: 1 };
            breakpoints[bp[4]] = { slidesPerView: t.desktop, slidesPerColumn: 1 };
          }
        } else {
          // Standard 4-breakpoint
          breakpoints[bp[0]] = { slidesPerView: t.mobile, slidesPerColumn: 1 };
          breakpoints[bp[1]] = { slidesPerView: t.tablet, slidesPerColumn: 1 };
          breakpoints[bp[2]] = { slidesPerView: t.laptop, slidesPerColumn: 1 };
          breakpoints[bp[3]] = { slidesPerView: t.desktop, slidesPerColumn: 1 };
          // Per-breakpoint spaceBetween overrides
          if (cfg.mobileSpace) breakpoints[bp[0]].spaceBetween = cfg.mobileSpace;
          if (cfg.tabletSpace) breakpoints[bp[1]].spaceBetween = cfg.tabletSpace;
        }
      }

      // Pagination or scrollbar
      var pagination = cfg.scrollbar ? false : {
        el: this.slider.querySelector('.swiper-pagination'),
        clickable: true
      };
      var scrollbar = cfg.scrollbar ? {
        el: this.slider.querySelector('.swiper-pagination'),
        hide: true
      } : false;

      // Build final options
      var opts = $.extend(true, {
        init: false,
        spaceBetween: cfg.space,
        loop: loop,
        preventClicks: true,
        preventClicksPropagation: true,
        autoplay: autoplay,
        centeredSlides: centered,
        navigation: {
          nextEl: this.slider.querySelector('.swiper-button-next'),
          prevEl: this.slider.querySelector('.swiper-button-prev')
        },
        lazy: true,
        focusableElements: 'input, select, option, textarea, video, label'
      }, t.options);

      if (pagination) opts.pagination = pagination;
      if (scrollbar) opts.scrollbar = scrollbar;
      if (Object.keys(breakpoints).length > 0) opts.breakpoints = breakpoints;
      if (cfg.vertical) opts.direction = 'vertical';
      if (cfg.mousewheel) { opts.mousewheel = true; opts.slidesPerView = 1; }

      var container = this.slider.querySelector('[' + cfg.sel + ']');
      var swiper = new Swiper(container, opts);
      swiper.on('init', function() { swiper.update(); });
      swiper.init();
    }
  }

  // Register the unified class under all 14 tag names
  Object.keys(SLIDER_CONFIGS).forEach(function(tag) {
    customElements.define(tag, class extends UnifiedSwiper { constructor() { super(); } });
  });
})();

/* Collection Slider (coverflow effect) - kept separate due to unique effect config */
class CollectionSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[data-slider-options]');
    this.init();
  }
  init() {
    var e = this.slider.getAttribute('data-slider-options');
    if (e === null || e === '') return;
    var t = $.extend(true, {
      direction: 'horizontal', autoplay: true, autoplaySpeed: 5, center: true, options: {}
    }, JSON.parse(e));
    var isNum = /^\d+$/;
    Object.keys(t).forEach(function(k) { if (typeof t[k] === 'string' && isNum.test(t[k])) t[k] = parseInt(t[k], 10); });
    var autoplay = false;
    if (t.auto_play > 0) autoplay = { delay: t.auto_play * 1000 };
    var loop = false, centered = false;
    if (t.loop === 'true' || t.loop === true) loop = true;
    else if (t.loop === 1) { loop = true; centered = true; }
    var opts = $.extend(true, {
      init: false, loop: loop, autoplay: autoplay, centeredSlides: centered,
      effect: 'coverflow', spaceBetween: 0,
      coverflowEffect: { rotate: 0, stretch: 0, depth: 300, modifier: 1, slideShadows: true },
      navigation: { nextEl: this.slider.querySelector('.swiper-button-next'), prevEl: this.slider.querySelector('.swiper-button-prev') },
      pagination: { el: this.slider.querySelector('.swiper-pagination'), clickable: true },
      lazy: true,
      focusableElements: 'input, select, option, textarea, video, label',
      breakpoints: {
        320: { slidesPerView: t.mobile, slidesPerColumn: 1 },
        560: { slidesPerView: t.tablet, slidesPerColumn: 1 },
        768: { slidesPerView: t.desktop, slidesPerColumn: 1 },
        992: { slidesPerView: t.desktop, slidesPerColumn: 1 }
      }
    }, t.options);
    var container = this.slider.querySelector('[data-collection-slider]');
    var swiper = new Swiper(container, opts);
    swiper.on('init', function() { swiper.update(); });
    swiper.init();
  }
}
customElements.define('collection-slider', CollectionSlider);

/* ═══ Accordion ═══ */
class Accordion {
  constructor(i) {
    this.el = i; this.summary = i.querySelector('summary'); this.content = i.querySelector('.accordion__content');
    this.animation = null; this.isClosing = false; this.isExpanding = false;
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }
  onClick(i) {
    i.preventDefault(); this.el.style.overflow = 'hidden';
    this.isClosing || !this.el.open ? this.open() : (this.isExpanding || this.el.open) && this.shrink();
  }
  shrink() {
    this.isClosing = true;
    var h = this.el.offsetHeight + 'px', sh = this.summary.offsetHeight + 'px';
    this.animation && this.animation.cancel();
    this.animation = this.el.animate({ height: [h, sh] }, { duration: 400, easing: 'ease-out' });
    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }
  open() {
    this.el.style.height = this.el.offsetHeight + 'px'; this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }
  expand() {
    this.isExpanding = true;
    var h = this.el.offsetHeight + 'px', th = (this.summary.offsetHeight + this.content.offsetHeight) + 'px';
    this.animation && this.animation.cancel();
    this.animation = this.el.animate({ height: [h, th] }, { duration: 400, easing: 'ease-out' });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }
  onAnimationFinish(i) {
    this.el.open = i; this.animation = null; this.isClosing = false; this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = '';
  }
}
document.querySelectorAll('.dt-details').forEach((i) => { new Accordion(i); });

/* ═══ jQuery accordion ═══ */
$('#accordian li').click(function() {
  var e = $(this), o = e.closest('ul'), t = o.find('.active'), i = e.closest('li'), l = i.hasClass('active'), s = 0;
  o.find('ul').slideUp(function() { ++s == o.find('ul').length && t.removeClass('active'); });
  l || (i.children('ul').slideDown(), i.addClass('active'));
});

/* ═══ Footer toggles ═══ */
if ($('.footer-links').length > 0) {
  $('.footer-links').each(function() {
    $(this).on('click', function() { $(this).toggleClass('open'); });
  });
}
if ($('.footer_address').length > 0) {
  $('.footer_address').each(function() {
    $(this).on('click', function() { $(this).toggleClass('open'); });
  });
}

/* ═══ Shop the Look (uses Slick) ═══ */
class shopLook extends HTMLElement {
  constructor() {
    super();
    this.look = this.querySelector('[id^="shop-look-selector-"]');
    this.slider = this.look.querySelector('.quotes-slider');
    this.navigation = this.look.querySelector('.quote-navigation');
    this.navControls = this.look.querySelector('.carousel-arrow');
    this.Init();
  }
  Init() {
    if (!this.look) return;
    $(this.slider).slick({
      slidesToShow: 1, centerMode: false, centerPadding: '200px', loop: true,
      arrows: true, dots: false, asNavFor: this.navigation,
      appendArrows: this.navControls,
      prevArrow: '<a class="prev-arrow"></a>', nextArrow: '<a class="next-arrow"></a>',
      responsive: [
        { breakpoint: 1541, settings: { centerPadding: '100px' } },
        { breakpoint: 1200, settings: { centerPadding: '60px' } },
        { breakpoint: 1024, settings: { centerPadding: '40px' } },
        { breakpoint: 501, settings: { centerPadding: '0px' } }
      ]
    });
    $(this.navigation).slick({
      slidesToShow: 5, asNavFor: this.slider, dots: false, focusOnSelect: true, loop: false, arrows: false
    });
  }
}
customElements.define('shop-the-look', shopLook);
document.addEventListener('shopify:section:load', function() { slick(); });

/* ═══ Account modal ═══ */
let accountModel = document.querySelector('[id^="login-modal__"]');
let accountButton = document.querySelector('.header__icon--account');
let accountClose = document.querySelector('.details-modal-close');
if (accountButton) {
  accountButton.addEventListener('click', function() {
    accountModel.classList.toggle('login-modal-active');
  });
  if (accountClose) {
    accountClose.addEventListener('click', function() {
      accountModel.classList.remove('login-modal-active');
    });
  }
}

/* ═══ Reveal on scroll ═══ */
const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) entry.target.classList.add('reveal');
  });
});
document.querySelectorAll('.shopify-section').forEach((el) => observer.observe(el));

/* ═══ Swiper arrow positioning ═══ */
document.querySelectorAll('[id^="shopify-section-"]').forEach((card) => {
  if (card.classList.contains('section-featured-collection') || card.classList.contains('section-collection-list')) {
    const topHeading = card.querySelectorAll('.for-arrow-alignment');
    const cardHeight = parseInt(topHeading[0].clientHeight);
    const topValue = cardHeight / 2 + 5;
    const cardTopCSS = 'calc(50% - ' + topValue + 'px)';
    const swiperContainer = card.querySelector('.swiper');
    const swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');
    const swiperNextElement = swiperContainer.querySelector('.swiper-button-next');
    if (!swiperPrevElement || !swiperNextElement) return;
    swiperPrevElement.setAttribute('style', 'top:' + cardTopCSS);
    swiperNextElement.setAttribute('style', 'top:' + cardTopCSS);
  }
});

/* ═══ Testimonial arrow positioning ═══ */
document.querySelectorAll('[id^="shopify-section-"]').forEach((card) => {
  if (card.classList.contains('index-section--quotes')) {
    const topHeading = card.querySelectorAll('.for-arrow-alignment');
    const cardHeight = parseInt(topHeading[0].clientHeight);
    const topValue = cardHeight / 2 + 5;
    const cardTopCSS = 'calc(50% - ' + topValue + 'px)';
    const swiperContainer = card.querySelector('.carousel-arrow');
    const swiperPrevElement = swiperContainer.querySelector('.prev-arrow');
    const swiperNextElement = swiperContainer.querySelector('.next-arrow');
    if (!swiperPrevElement || !swiperNextElement) return;
    swiperPrevElement.setAttribute('style', 'top:' + cardTopCSS);
    swiperNextElement.setAttribute('style', 'top:' + cardTopCSS);
  }
});

/* ═══ Variant swatch color handler ═══ */
function handleSwatchGroups(container) {
  container.querySelectorAll('.variant-option-color').forEach(function(swatchGroup) {
    var swatches = swatchGroup.querySelectorAll('.color-values');
    var maxVisible = 3;
    if (swatches.length > maxVisible) {
      swatches.forEach(function(swatch, index) {
        if (index >= maxVisible) { swatch.classList.add('hidden-swatch'); swatch.style.display = 'none'; }
      });
      var toggleBtn = swatchGroup.querySelector('.color-values-plus a');
      if (toggleBtn && !toggleBtn.dataset.bound) {
        toggleBtn.dataset.bound = 'true';
        toggleBtn.addEventListener('click', function(e) {
          e.preventDefault();
          swatches.forEach(function(s) { s.style.display = 'inline-block'; });
          toggleBtn.closest('.color-values-plus').style.display = 'none';
        });
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  handleSwatchGroups(document);
  var obs = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      if (m.type === 'childList') {
        m.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) handleSwatchGroups(node);
        });
      }
    });
  });
  obs.observe(document.body, { childList: true, subtree: true });
});
